/**
 * The genres a singer can pick on first run. The web app renders this list
 * as chips and the server accepts nothing outside it.
 */
export const GENRES = [
  "Pop",
  "Rock",
  "Nineties",
  "Motown",
  "Country",
  "Hip-hop",
  "Afrobeats",
  "Musicals",
  "Ballads",
  "K-pop",
  "Disco",
  "Metal",
] as const;

export type Genre = (typeof GENRES)[number];

const isGenre = (value: string): value is Genre =>
  (GENRES as readonly string[]).includes(value);

export type GenresValidation =
  | { ok: true; genres: Genre[] }
  | { ok: false; reason: string };

/** Dedupe and reject anything outside the catalog. Order is preserved. */
export function validateGenres(raw: string[]): GenresValidation {
  const genres: Genre[] = [];
  for (const value of raw) {
    if (!isGenre(value)) return { ok: false, reason: `Unknown genre "${value}"` };
    if (!genres.includes(value)) genres.push(value);
  }
  return { ok: true, genres };
}
